import { checkRoles, useRoles, FeatureFlagRoles, useIsGlobalAdmin } from '@edge/spark/io-roles'

const ALLOW_AE_ADMINS = true
const REQUIRED_ROLES = [`${FeatureFlagRoles.EDIT_VEHICLE_SALE_CONDITIONS}`]

/** Check authorization for EditSaleConditions Action Drawer */
export const useIsAuthorized = () => {
    const isEdgeAdmin = useIsGlobalAdmin()
    const isAuthorizedAsEdgeAdmin = ALLOW_AE_ADMINS && isEdgeAdmin
    const roles = useRoles({ skip: isAuthorizedAsEdgeAdmin })

    if (isAuthorizedAsEdgeAdmin) {
        return true
    }

    const foundRole = checkRoles(roles, REQUIRED_ROLES)

    return foundRole
}
